module.exports = __webpack_public_path__ + "static/icon_milano_nordest_nero-9f4f211bc21deb824bb29fbb6b568324.svg";